import React from "react";
import PropTypes from "prop-types";
import distanceInWordsToNow from "date-fns/distance_in_words_to_now";
import differenceInSeconds from "date-fns/difference_in_seconds";

//Material imports
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import { locale } from "@limitless/common/utils";
import { findInboxExpiryTime } from "@limitless/expert/utils/InboxExpiryHelper";
import ModernTenantAvatar from "../modern-tenant-avatar/ModernTenantAvatar";
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import { TimeLeftCell } from "@limitless/portal";

const useStyles = makeStyles(() => ({
    header: {
        minWidth: "49%",
        display: "flex",
        flexDirection: "row"
    },
    textWrapping: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontWeight: 600
    },
    timeContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        maxWidth: "49%"
    }
}));

const ModernTaskListHeader = ({ message }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const translate = React.useMemo(() => locale(t, true), []);

    const expiryTime = findInboxExpiryTime(message);

    const distanceInWords = distanceInWordsToNow(new Date(expiryTime), {
        includeSeconds: true,
        addSuffix: false,
        locale: locale(t, true)
    });

    const currentTime = Date.now();
    const diff = Math.floor((expiryTime - currentTime) / 1000);

    return (
        <Grid container justifyContent="space-between" direction="row" alignItems="center">
            <div className={classes.header}>
                <Typography color="textPrimary" variant="body1" mr={1}>
                    {message.displayName ? message.displayName : message.groupName}
                </Typography>
                <ModernTenantAvatar tenantName={message.tenantName} />
            </div>
            <div className={classes.timeContainer}>
                <Typography
                    variant="caption"
                    color={
                        distanceInWords.includes("minute") || distanceInWords.includes("second")
                            ? "error.dark"
                            : "warning.grey"
                    }
                >
                    {diff < 60 || (Number.isNaN(diff) && message.type === "respondSticky") ? (
                        <TimeLeftCell value={expiryTime || 0} localiseDate={translate.distanceInWords.localize} />
                    ) : (
                        distanceInWords
                    )}
                </Typography>
            </div>
        </Grid>
    );
};

export default ModernTaskListHeader;

ModernTaskListHeader.propTypes = {
    message: PropTypes.object.isRequired
};
